import { normalizeTenantId } from '@/lib/tenantUtils';

const API_BASE = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/+$/, "");

/** Default timeout for normal API requests (2 min) */
const DEFAULT_TIMEOUT_MS = 120000;

/** Timeout for long-running message/playbook generation (5 min) */
export const GENERATION_TIMEOUT_MS = 300000;

export function apiUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${p}` : p;
}

function getTenantId() {
  const isAdmin = localStorage.getItem('user-role') === 'admin';
  const adminTenant = isAdmin ? localStorage.getItem('admin-active-tenant') : null;
  const runtimeSessionTenant = typeof window !== 'undefined' ? window.__NEO_SESSION_TENANT_ID : null;
  const raw = adminTenant || runtimeSessionTenant || localStorage.getItem('user-tenant-id') || 'instructure';
  return normalizeTenantId(raw) || raw || 'instructure';
}

function getUserId() {
  return localStorage.getItem('user-id') || '';
}

export async function apiFetch(path, options = {}) {
  const headers = { ...options.headers };
  
  // Don't set Content-Type for FormData - browser handles it
  const isFormData = options.body instanceof FormData;
  
  if (!isFormData) {
    headers['X-Tenant-ID'] = getTenantId();
    const userId = getUserId();
    if (userId) {
      headers['X-User-ID'] = userId;
    }
  } else {
    // For FormData, we still need tenant/user headers
    headers['X-Tenant-ID'] = getTenantId();
    const userId = getUserId();
    if (userId) {
      headers['X-User-ID'] = userId;
    }
  }

  const timeoutMs = options.timeoutMs ?? DEFAULT_TIMEOUT_MS;
  const { timeoutMs: _omit, ...restOptions } = options;
  const signal = restOptions.signal ?? (typeof AbortSignal?.timeout === 'function' ? AbortSignal.timeout(timeoutMs) : undefined);
  return fetch(apiUrl(path), { ...restOptions, headers, signal });
}